import dynamic from 'next/dynamic';
import { forwardRef, useImperativeHandle, useState } from 'react';

const ProductExtrasDialog = dynamic(() => import('@components/Components/ProductComponent/ProductExtrasDialog'), { ssr: false });

/**
 * The options dialog of a list of products, with the state of whether it is open and what it was opened with kept here and not in the
 * list. Opening or closing it draws only this component: the list (every tile of it, on a long search) is not drawn again.
 * `ref.current.open(extrasData)` opens it; see `extrasDialogData` for what it is opened with.
 */
const ProductExtrasDialogHost = forwardRef(function ProductExtrasDialogHost(props, ref) {
    const [extrasData, setExtrasData] = useState(null);

    useImperativeHandle(ref, () => ({ open: setExtrasData }), []);

    if (!extrasData?.product?.product_id) return null;

    return <ProductExtrasDialog extrasData={extrasData} open toggle={() => setExtrasData(null)} />;
});

export default ProductExtrasDialogHost;
